import { render, staticRenderFns } from "./code-of-conduct.vue?vue&type=template&id=f59ec6e6&scoped=true"
import script from "./code-of-conduct.vue?vue&type=script&lang=js"
export * from "./code-of-conduct.vue?vue&type=script&lang=js"
import style0 from "./code-of-conduct.vue?vue&type=style&index=0&id=f59ec6e6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59ec6e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f59ec6e6')) {
      api.createRecord('f59ec6e6', component.options)
    } else {
      api.reload('f59ec6e6', component.options)
    }
    module.hot.accept("./code-of-conduct.vue?vue&type=template&id=f59ec6e6&scoped=true", function () {
      api.rerender('f59ec6e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/sections/code-of-conduct.vue"
export default component.exports